import {Autocomplete, Box, createFilterOptions, LinearProgress, TextField} from "@mui/material";
import React from "react";
import {OperationApiGet, useGetOperationQuery} from "./operation_api";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import {PersonApiGet} from "../people/people_api";
import AvatarImage from "../storage/AvatarImage";


export default ({onChange, value}: MultiSearchProps<Tables<"workTask">>) => {

    const {data, isFetching} = useGetOperationQuery({});
    
    if (isFetching ) {
        return  <LinearProgress/>
    }

    return <Autocomplete
        id={"OperationApiGet"}
        multiple
        options={data || []}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        onChange={(e, v: OperationApiGet[]) => onChange(v)}
        getOptionLabel={(option: OperationApiGet) => {
            return option.Code;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.Code + " " + option.Name,
        })}
        renderOption={(props, option: OperationApiGet) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"avatars"}/> {option.Code} {option.Name}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label="Operacija"
                variant={"standard"}
            />
        )}
    />

}
